import React, { useState } from 'react';
import get from 'lodash/get';

import ModalContext from './ModalContext';

const ModalProvider = ({ children }) => {
  const [componentState, setComponentState] = useState(null);

  const onClose = get(componentState, 'onClose', null);

  const showModal = (component, id, props, overlayType, onClose) => {
    setComponentState({ component, id, props, overlayType, onClose });
  };

  const hideModal = () => {
    if (onClose) {
      onClose();
    }
    setComponentState(null);
  };

  const context = {
    component: get(componentState, 'component', null),
    props: get(componentState, 'props', {}),
    overlayType: get(componentState, 'overlayType', 'touchclose'),
    activeId: get(componentState, 'id', null),
    onClose,
    showModal,
    hideModal
  };

  return (
    <ModalContext.Provider value={context}>{children}</ModalContext.Provider>
  );
};

export default ModalProvider;
